import { TicketVideoCallContainer } from "./styles";
import { useCountdown } from "hooks/useCountdown";
import { useTranslation } from "react-i18next";
import React from "react";
import config from "network/config";
const { apiOrigin } = config;

export const TicketVideoCall = ({
	ticketId,
	theme,
	lastTicketCalled,
	isBetaMeetActive,
	token,
	office,
}) => {
	const { t } = useTranslation("waitingRoom");

	const handleVideoCall = (betaMeet, token, officeSlug) => {
		if (betaMeet) {
			window.open(
				`${apiOrigin}/meet/verify/${token}?tuid=${ticketId}&officeSlug=${officeSlug}`,
				"_blank"
			);
			return;
		}
		window.open(` https://meet.zeroq.cl/${ticketId} `, "_blank");
	};

	const timeLeftToJoin = useCountdown({
		type: "minutes",
		time: 5,
		reset: false,
	});
	const categoryId = office?.category_id;

	return (
		<TicketVideoCallContainer theme={theme}>
			{theme.yourTurnLogo && (
				<img
					src={theme.yourTurnLogo}
					alt="Logo"
					className="ticket__videoCall-logo"
				/>
			)}

			<p className="queue-information__title">
				{categoryId === 33 ? t("subtitle") : office.name}
			</p>
			<span className="ticket__videoCall-mainText">¡Es tu turno!</span>
			<img src={theme.gif} alt="videoCallIcon" />

			<div
				className="ticket__videoCall-joinBtn"
				onClick={() =>
					handleVideoCall(isBetaMeetActive, token, office.slug || "")
				}
			>
				Unirme a la videollamada
			</div>

			{ticketId === lastTicketCalled || timeLeftToJoin === 0 ? (
				<p className="ticket__videocall-bottomText">
					Una véz llamado, tienes 5 minutos para unirte
				</p>
			) : (
				<p className="ticket__videocall-bottomText">
					Tienes
					<span> {timeLeftToJoin} minutos </span>
					para unirte a la videollamada
				</p>
			)}
		</TicketVideoCallContainer>
	);
};
